var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage, FormattedDate, FormattedTime, injectIntl } from 'react-intl';
import classNames from 'classnames';
import { ApplicationContext } from '../../../ApplicationContext';
import UnarchiveAssetCommand from '../../../commands/assets/UnarchiveAssetCommand';
/**
 *
 */
var AssetArchiveRow = /** @class */ (function (_super) {
    __extends(AssetArchiveRow, _super);
    /**
     *
     */
    function AssetArchiveRow(props) {
        var _this = _super.call(this, props) || this;
        _this.onUnarchive = _this.onUnarchive.bind(_this);
        return _this;
    }
    /**
     *
     * @returns {*}
     */
    AssetArchiveRow.prototype.render = function () {
        var session = this.context.session;
        var archivedAssetModel = this.props.archivedAssetModel;
        var classes = classNames({
            'asset-archive-row': true,
            "bg-white": true,
            "w-100": true,
            'mb-4': true,
            "pl-3": true,
            "pr-3": true,
            'pt-4': true,
            'pb-4': true,
        });
        return (React.createElement("div", { style: { display: "contents" }, key: 'archived-asset-' + archivedAssetModel.assetId, className: classes },
            React.createElement("div", { className: "pl-4 text-nowrap" }, archivedAssetModel.alias ? archivedAssetModel.alias : (archivedAssetModel.equipmentId ? archivedAssetModel.equipmentId : archivedAssetModel.assetId)),
            React.createElement("div", { className: "text-nowrap" }, archivedAssetModel.make),
            React.createElement("div", { className: "text-nowrap" }, archivedAssetModel.model),
            React.createElement("div", { className: "text-nowrap" }, archivedAssetModel.assetId),
            React.createElement("div", { className: "text-nowrap" },
                React.createElement(FormattedDate, { value: archivedAssetModel.lastModifiedTimestamp }),
                " ",
                React.createElement(FormattedTime, { value: archivedAssetModel.lastModifiedTimestamp })),
            React.createElement("div", null, archivedAssetModel.reason),
            React.createElement("div", { className: "pr-4 align-middle text-nowrap" }, session.user && session.user.isOwner &&
                React.createElement("button", { className: "btn btn-sm btn-outline-danger", onClick: this.onUnarchive },
                    React.createElement(FormattedMessage, { id: "asset.unarchive" })))));
    };
    /**
     *
     */
    AssetArchiveRow.prototype.onUnarchive = function () {
        var session = this.context.session;
        var _a = this.props, archivedAssetModel = _a.archivedAssetModel, archivedAssetCollection = _a.archivedAssetCollection, intl = _a.intl;
        var command = new UnarchiveAssetCommand();
        command.execute(session.user.organisation, archivedAssetModel, archivedAssetCollection, intl);
    };
    AssetArchiveRow = __decorate([
        observer
    ], AssetArchiveRow);
    return AssetArchiveRow;
}(React.Component));
AssetArchiveRow.contextType = ApplicationContext;
export default injectIntl(AssetArchiveRow);
